/**
 * Rounds a number to 2 decimal places, handling floating point precision issues.
 * Uses Number.EPSILON to avoid floating point rounding errors.
 *
 * @example
 * floatify(0.1 + 0.2) // returns 0.3 instead of 0.30000000000000004
 * floatify(1.005) // returns 1.01
 * floatify(10.255) // returns 10.26
 */
export function floatify(n: number): number {
  return Math.round((n + Number.EPSILON) * 100) / 100;
}

/** Major units when hydrating stored whole-cent amounts. */
export function centsToDollars(cents: number | string | undefined | null): number {
  return floatify(Number(cents ?? 0) / 100);
}

/**
 * Whole cents for custom-offer-style API payloads (floatify then round).
 * Prefer over getStripeAmount when you need custom-offer rounding, not Stripe ceil / zero-decimal rules.
 */
export function dollarsToCents(dollars: number): number {
  return Math.round((floatify(dollars) + Number.EPSILON) * 100);
}
